import React, { PropsWithChildren } from 'react';
import { ErrorBoundary as ImportedErrorBoundary } from 'react-error-boundary';
import { AppErrorBoundaryTemplate } from './AppErrorBoundaryTemplate';
import { handleError, handleReset } from './errorBoundary.helpers';
import {
  ErrorBoundary,
  ErrorBoundaryTemplate
} from './errorBoundary.interfaces';

/** Component that is rendered in the event of an error. */
function RenderedError({ resetErrorBoundary }: ErrorBoundaryTemplate) {
  return <AppErrorBoundaryTemplate resetErrorBoundary={resetErrorBoundary} />;
}

export function AppErrorBoundary({
  children
}: PropsWithChildren<ErrorBoundary>) {
  return (
    <ImportedErrorBoundary
      FallbackComponent={RenderedError}
      onError={handleError}
      onReset={handleReset}
    >
      {children}
    </ImportedErrorBoundary>
  );
}
